/* eslint-disable no-restricted-syntax */
import { PaymentMethod } from '../../../../core/reducers/financialCalculators';
import { tabType, tabTypeToPaymentMethodMap } from '../../constants';
import { OfferTypes } from '../../../../core/types';
import { CUSTOMER_CASH_REBATE_NAME } from '../../../../utils/constants';
var PaymentTabLabel;
(function (PaymentTabLabel) {
    PaymentTabLabel["lease"] = "Shared.Common.leaseMethodLabel";
    PaymentTabLabel["finance"] = "Shared.Common.financeMethodLabel";
    PaymentTabLabel["rebate"] = "Shared.Common.rebateMethodLabel";
})(PaymentTabLabel || (PaymentTabLabel = {}));
/**
 * Sorts offers by their type, ensuring that non-stackable offers come after stackable ones.
 *
 * @param {Offer} a
 * @param {Offer} b
 * @return {*}
 */
const sortByOfferType = (a, b) => {
    const isANonStackable = (a === null || a === void 0 ? void 0 : a.type) === OfferTypes.NonStackableRebate;
    const isBNonStackable = (b === null || b === void 0 ? void 0 : b.type) === OfferTypes.NonStackableRebate;
    if ((isANonStackable && isBNonStackable) || (!isANonStackable && !isBNonStackable)) {
        // If both are non-stackable or both are stackable, maintain original order
        return 0;
    }
    // If A is non-stackable and B is stackable, A should come after B
    if (isANonStackable && !isBNonStackable) {
        return 1;
    }
    return -1;
};
function getAvailableOffers(paymentMethod, offers, hasLoyaltyOffer) {
    var _a, _b, _c;
    const sortedOffers = [];
    const incentiveOffers = (_a = offers.incentiveOffers[paymentMethod]) !== null && _a !== void 0 ? _a : [];
    const loyaltyOffers = (_b = offers.loyaltyOffers[paymentMethod]) !== null && _b !== void 0 ? _b : [];
    const bonusOffers = (_c = offers.bonusOffers[paymentMethod]) !== null && _c !== void 0 ? _c : [];
    for (const { key, name, value, type } of incentiveOffers) {
        if (name !== CUSTOMER_CASH_REBATE_NAME) {
            sortedOffers.push({ key, name, value, type: type });
        }
    }
    // sort incentiveOffer by non-stackable vs stackable
    sortedOffers.sort(sortByOfferType);
    if (hasLoyaltyOffer) {
        for (const { key, name } of loyaltyOffers) {
            sortedOffers.push({ key, name, type: OfferTypes.Loyalty });
        }
    }
    for (const { title, description } of bonusOffers) {
        sortedOffers.push({ key: title.value, name: title.value, disclaimer: description.value, type: 'bonus' });
    }
    return sortedOffers;
}
const getCustomerCashRebate = (paymentMethod, incentiveOffers) => { var _a, _b; return ((_b = (_a = incentiveOffers === null || incentiveOffers === void 0 ? void 0 : incentiveOffers[paymentMethod]) === null || _a === void 0 ? void 0 : _a.find(({ name }) => name === CUSTOMER_CASH_REBATE_NAME)) === null || _b === void 0 ? void 0 : _b.value) || 0; };
function buildPaymentTab({ type, offers, payment, financials, fallbackPaymentFrequency, specialRates, hasLoyaltyOffer, }) {
    const paymentMethod = tabTypeToPaymentMethodMap[type];
    const availableOffers = getAvailableOffers(paymentMethod, offers, hasLoyaltyOffer);
    const paymentAmount = (payment === null || payment === void 0 ? void 0 : payment.preferredPaymentAmount) || 0;
    let cashRebate = 0;
    if (type === tabType.rebate) {
        cashRebate = getCustomerCashRebate(PaymentMethod.cash, offers.incentiveOffers);
        if (!cashRebate && !availableOffers.length)
            return null;
        return {
            type,
            key: type,
            label: PaymentTabLabel[type],
            content: {
                rebateAmount: cashRebate,
                availableOffers,
            },
        };
    }
    const { defaultFinancePaymentFrequency, defaultLeasePaymentFrequency } = financials;
    const defaultFrequencies = {
        lease: defaultLeasePaymentFrequency,
        finance: defaultFinancePaymentFrequency,
    };
    const specialRate = specialRates === null || specialRates === void 0 ? void 0 : specialRates[type];
    const term = (payment === null || payment === void 0 ? void 0 : payment.term) || 0;
    const paymentFrequency = (defaultFrequencies[type] || fallbackPaymentFrequency);
    const apr = (payment === null || payment === void 0 ? void 0 : payment.apr) || 0;
    cashRebate = getCustomerCashRebate(tabTypeToPaymentMethodMap[type], offers.incentiveOffers);
    return {
        type,
        key: type,
        label: PaymentTabLabel[type],
        content: {
            apr,
            term,
            hasSpecialRate: !!specialRate,
            paymentAmount,
            paymentFrequency,
            paymentMethod,
            availableOffers,
            cashRebate: !cashRebate ? undefined : { rebateAmount: cashRebate },
        },
    };
}
export default buildPaymentTab;
